import React from 'react'

import Base from '../_Base'

const Brazil18 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_18)">
      <rect width="24" height="24" rx="2" fill="#000" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.777 13.729v.952c0 .505.04.84.12.992.079.153.22.233.425.233.198 0 .34-.085.42-.26.078-.177.118-.494.118-.965v-.952c0-.499-.04-.828-.113-.98-.08-.154-.216-.233-.42-.233s-.345.085-.425.25c-.085.164-.125.487-.125.963Zm.04-4.422v.5c0 .515.034.85.108.997.073.153.204.227.39.227a.375.375 0 0 0 .375-.25c.068-.164.102-.493.102-.98v-.5c0-.498-.034-.827-.108-.986-.073-.159-.198-.238-.385-.238a.387.387 0 0 0-.38.25c-.068.17-.102.498-.102.98Zm-.63 2.42a1.778 1.778 0 0 1-.986-.674c-.238-.329-.357-.72-.357-1.179v-.572c0-.862.193-1.48.584-1.866.386-.385 1.02-.572 1.894-.572.867 0 1.496.193 1.876.572.386.38.573 1.004.573 1.866v.572c0 .46-.12.856-.352 1.185-.232.329-.561.55-.98.669.447.13.793.368 1.031.72.238.346.357.788.357 1.32v.925c0 .861-.198 1.48-.6 1.865-.397.385-1.038.578-1.922.578-.885 0-1.525-.193-1.917-.573-.39-.38-.584-1.003-.584-1.87v-.924c0-.539.12-.981.352-1.327.232-.346.578-.584 1.032-.714ZM8.596 7.028h1.683v9.938H8.357V9.579c-.164.17-.345.323-.544.448a2.924 2.924 0 0 1-.64.312V8.553c.345-.193.635-.42.873-.674.243-.255.425-.539.55-.85Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_18">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default Brazil18
